import { createFileRoute } from '@tanstack/react-router';
import { ReportingScorecards } from '@/components/organisms/analytics-reports/ReportingScorecards';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/scorecards')({
  component: ReportingScorecards,
});
